<div id="main-wrapper">
    <!-- ============================================================== -->
    <!-- Topbar header - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <header [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="topbar">
        <nav class="navbar top-navbar navbar-expand-md navbar-light">
            <!-- ============================================================== -->
            <!-- Logo -->
            <!-- ============================================================== -->
            <div class="navbar-header d-none d-md-block">
                <a [href]="(domainService.logoLink$ | async) ? (domainService.logoLink$ | async) : '/'" target="_blank" class="navbar-brand" >
                    <!-- Logo icon --><b>
                        <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                        <!-- Dark Logo icon -->
                        <img *ngIf="!(domainService.logoUrl$ | async)" src="assets/images/favicon.png" width="40" alt="homepage" class="dark-logo" />
                        <!-- Light Logo icon -->
                    </b>
                    <!--End Logo icon -->
                    <!-- Logo text -->
                  <span>
                     <!-- dark Logo text -->
                     <img *ngIf="!(domainService.logoUrl$ | async)" src="assets/images/text.png" width="120" alt="homepage" class="dark-logo" />
                     <img *ngIf="(domainService.logoUrl$ | async)" [src]="(domainService.logoUrl$ | async)" width="120" alt="homepage" class="dark-logo" />
                     <!-- Light Logo text -->    
                  </span> 
                </a>
            </div>
            <!-- ============================================================== -->
            <!-- End Logo -->
            <!-- ============================================================== -->
            <div *ngIf="!(userService.isGuest$ | async) && !(testService.isLocal$ | async)" class="navbar-collapse">
                <!-- ============================================================== -->
                <!-- toggle and nav items -->
                <!-- ============================================================== -->
                <ul class="navbar-nav ">
                    <!-- This is  -->
                    <li class="nav-item"> <a class="nav-link nav-toggler hidden-md-up waves-effect waves-dark" href="javascript:void(0)" (click)="stateService.setShowSidebar(!stateService.showSidebar)" ><i [ngClass]="(stateService.showSidebar$ | async) ? 'ti-close' : 'ti-menu'" ></i></a> </li>
                    <!-- <li class="nav-item"> <a class="nav-link sidebartoggler hidden-sm-down waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a> </li> -->
                    <!-- <li class="nav-item hidden-sm-down"></li> -->
                </ul>

                <ul style="margin-left: 40px;" class="navbar-nav mr-auto">
                    
                    <li>
                        <small *ngIf="user&&user.role!='evaluated'" class="text-white">Bienvenido {{user.alias | slice : 0 : 10}}
                            <!-- <a style="margin-left: 10px;" *ngIf="(!user.name||!user.country||!user.surname)&&user.role=='client'" [routerLink]="'myAccount'"><b class="text-danger">Por favor completa tu perfil AQUÍ</b></a> -->
                        </small>
                        
                    </li>

                    <li><small *ngIf="user&&user.role=='evaluated'" class="text-white">Bienvenido {{user.name | slice : 0 : 10}}</small></li>
                </ul>

                <!-- ============================================================== -->
                <!-- User profile and search -->
                <!-- ============================================================== -->
                <ul class="navbar-nav my-lg-0">
                   
                    <!-- ============================================================== -->
                    <!-- mega menu -->
                    <!-- ============================================================== -->
      
                    <li class="nav-item dropdown mega-dropdown"> <a class="nav-link dropdown-toggle waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><small> Contáctenos</small></a>
                        <div class="dropdown-menu animated bounceInDown">
                            <ul class="mega-dropdown-menu row">
                                <li class="col-md-4 m-b-30">
                                    
                                </li>
                                <li class="col-md-4  m-b-30">
                                    <h4 class="m-b-20">CONTACTO</h4>
                                    <!-- Contact -->
                                    <form >
                                        
                                        <div class="form-group">
                                            <textarea class="form-control" [(ngModel)]="message" [ngModelOptions]="{standalone: true}" id="exampleTextarea" rows="6" placeholder="Mensaje"></textarea>
                                        </div>
                                        <button type="button" (click)="sendMessage()" class="btn btn-info">Enviar</button>
                                    </form>
                                </li>
                                <li class="col-md-4 m-b-30">
                                    
                                </li>
                            </ul>
                        </div>
                    </li>
                    <!-- ============================================================== -->
                    <!-- End mega menu -->
                    <!-- ============================================================== -->
                    
                    <!-- ============================================================== -->
                    <!-- Profile -->
                    <!-- ============================================================== -->
                    <li class="nav-item dropdown mega-dropdown"> <a class="nav-link dropdown-toggle waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="logout()" ><i class="fa fa-power-off"></i><small> Logout</small></a>


                </ul>
            </div>
        </nav>
    </header>



    <section *ngIf="(userService.user) && (userService.user.role == 'client' && !userService.user.canUseCustomTests && !userService.user.isEnterprise) && !(userService.userInTest$ | async)" class="promo-header">
        <p class="text-white mb-0">¡Expándete con nuestras nuevas <b>Evaluaciones Cognitivos-Laborales!</b></p>
        &nbsp;
        &nbsp;
        &nbsp;
        <button class="btn btn-sm btn-white waves-effect waves-light btn-rounded" [routerLink]="'plans'" [queryParams]="{type: 'subscription'}" >Suscripción Mensual/Anual</button>
    </section>
    <!-- ============================================================== -->
    <!-- End Topbar header -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <aside *ngIf="menu && !(testService.isLocal$ | async)" [ngClass]="(stateService.showSidebar$ | async)? 'open-sidebar' : 'close-sidebar'" class="left-sidebar">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar">
            <!-- Sidebar navigation-->
            <nav *ngIf="!(userService.isGuest$ | async)" class="sidebar-nav">
                <ul id="sidebarnav">

                    <li class="nav-small-cap">MENÚ</li>
                    
                    <li *ngIf="adminTests.length > 0" > <a class="has-arrow waves-effect waves-dark" aria-expanded="false"><span class="hide-menu">Pruebas</span></a>
                        <ul aria-expanded="false" class="collapse">
                            
                            <li *ngFor="let item of adminTests" > <a class="has-arrow waves-effect waves-dark" aria-expanded="false"><span class="hide-menu">{{item.title}} </span></a>
                                <ul aria-expanded="false" class="collapse">
                                    <li *ngFor="let i of item.options" ><a routerLinkActive="active" [ngClass]="bloquedNavigation?'bloqued':''" [routerLinkActiveOptions]="{exact: true}" [queryParams]="i.query" [routerLink]="i.link">{{i.title}} </a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>



                    <li *ngFor="let item of menu" > <a class="has-arrow waves-effect waves-dark" aria-expanded="false"><span class="hide-menu">{{item.title}} </span></a>
                        <ul aria-expanded="false" class="collapse">
                            <li *ngFor="let i of item.options" ><a routerLinkActive="active" [ngClass]="bloquedNavigation?'bloqued':''" [routerLinkActiveOptions]="{exact: true}" [queryParams]="i.query" [routerLink]="i.link">{{i.title}} </a></li>
                        </ul>
                    </li>




                    <li *ngIf="user && user.role == 'client'"><a routerLinkActive="active" [ngClass]="bloquedNavigation?'bloqued':''" [routerLinkActiveOptions]="{exact: true}" [routerLink]="'groups-info'">Cognitivo - Laborales</a></li>
                    <li><a routerLinkActive="active" *ngIf="user&&user.role!='admin'&&user.role!='evaluated'" [ngClass]="bloquedNavigation?'bloqued':''" [routerLinkActiveOptions]="{exact: true}" [routerLink]="'info'">Modo de uso </a></li>
                    <li><a routerLinkActive="active" [ngClass]="bloquedNavigation?'bloqued':''" [routerLinkActiveOptions]="{exact: true}" [routerLink]="'myAccount'">Mis datos</a></li>
                    <li class="nav-devider"></li>
                    <li *ngIf="user && user.role=='client' && !user.isUnlimited" class="nav-small-cap text-info"><span style="color: black;">PRUEBAS DISPONIBLES: </span><b [ngStyle]="{color : (domainService.customColor$ | async)}">{{user.remainingTests}}</b></li>
                    <li *ngIf="user && user.isEnterprise" class="nav-small-cap text-info"><span style="color: black;"><b>Plan Enterprise</b><br>Ilimitado - Anual</span></li>
                    <li *ngIf="user&&user.role=='client'&&!user.isEnterprise" class="nav-small-cap text-info"><span style="color: black;">VENCE: </span><b [ngStyle]="{color : (domainService.customColor$ | async)}">{{venc|date:'shortDate'}}</b></li>
                    <li *ngIf="user&&user.role=='client'&&user.isEnterprise&&!isSubAccount" class="nav-small-cap text-info"><span style="color: black;">VENCE: </span><b [ngStyle]="{color : (domainService.customColor$ | async)}">{{user.enterpriseExpireDate|date:'shortDate'}}</b></li>
                    <li *ngIf="user&&user.role=='client'&&user.isEnterprise&&isSubAccount" class="nav-small-cap text-info"><span style="color: black;">Cuenta secundaria</span></li>

                    <li *ngIf="user && user.isEnterprise && (user.subaccountLimit > subAccounts.length)" class="nav-small-cap text-info">
                        <button [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn btn-info waves-effect waves-light m-t-20 btn-rounded" [routerLink]="['/dashboard/accounts', user._id]"><small><b>Gestionar cuentas</b></small></button>
                    </li>


                    <li *ngIf="user && user.role == 'client'" class="nav-devider"></li>
                    <li *ngIf="user&&user.role=='client'" class="nav-small-cap text-info">
                        <button *ngIf="user && user.role=='client' && !inCustomDomain && !user.isEnterprise" [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn btn-info waves-effect waves-light m-t-20 btn-rounded" [routerLink]="'plans'"><small><b>COMPRAR PRUEBAS</b></small></button>
                    </li>
                    
                    
                    
                </ul>
            </nav>
            <!-- End Sidebar navigation -->
        </div>
        <!-- End Sidebar scroll-->
    </aside>
    <!-- ============================================================== -->
    <!-- End Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">

        <small *ngIf="user && (!user.name||!user.country||!user.surname ||!user.phone)&&user.role=='client'">
            <app-profile-complete-percent [percent]="profilePercent" ></app-profile-complete-percent>
        </small>

        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
        <div class="container-fluid">

            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            
            
            <router-outlet></router-outlet>

            <!-- <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            This is some text within a card block.
                        </div>
                    </div>
                </div>
            </div> -->




            <!-- ============================================================== -->
            <!-- End PAge Content -->
            <!-- ============================================================== -->

        </div>
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- footer -->
        <!-- ============================================================== -->
        <footer class="footer">
            © Evalúa Psi || evaluapsi.com
        </footer>
        <!-- ============================================================== -->
        <!-- End footer -->
        <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
</div>

<app-full-page-loader *ngIf="(stateService.isLoading$ | async)"></app-full-page-loader>